module.exports = __webpack_public_path__ + "static/media/about_03.707d17ec.png";